export default __webpack_public_path__ + "7dcd1ca2452b6407a90d525b728044b8.png";